import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const cards = [
    {
        slug: "minimal",
        title: "A) Ultra Premium Minimal",
        subtitle: "Daha sakin, daha net, daha kurumsal",
        bg: "from-zinc-950 via-neutral-900 to-black",
        accent: "#B9A16B",
        body: "İnce tipografi, yüksek boşluk, az ama çok güçlü bileşen dili.",
    },
    {
        slug: "editorial",
        title: "B) Cesur Editorial",
        subtitle: "Daha çarpıcı, daha karakterli, daha moda",
        bg: "from-[#130810] via-[#2A0F1E] to-[#0A0A0A]",
        accent: "#FF4D6D",
        body: "Büyük başlıklar, asimetrik grid, sert görsel hiyerarşi.",
    },
    {
        slug: "fintech",
        title: "C) Fintech Luxury",
        subtitle: "Daha güven odaklı, daha satışa dönük",
        bg: "from-[#081726] via-[#0E2135] to-[#0A0A0A]",
        accent: "#35D0FF",
        body: "Kurumsal bloklar, net CTA akışı, premium ama güvenli görünüm.",
    },
];

export default function DesignPreviewPage() {
    return (
        <main
            data-testid="design-preview-page"
            className="min-h-screen bg-[#08090B] text-white px-6 py-10 md:px-10"
        >
            <div className="max-w-6xl mx-auto">
                <div className="mb-8">
                    <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">
                        3 Mini Stil Önizleme
                    </h1>
                    <p className="text-sm md:text-base text-zinc-300 mt-3 max-w-2xl">
                        Bunlar sadece hızlı görsel yön demo’ları. Seçtiğiniz stile göre tüm siteyi tek seferde yeniden tasarlayacağım.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-4">
                    {cards.map((c) => (
                        <article
                            key={c.slug}
                            data-testid={`design-preview-card-${c.slug}`}
                            className={`rounded-2xl border border-white/10 p-5 bg-gradient-to-br ${c.bg}`}
                        >
                            <div
                                className="w-9 h-9 rounded-lg mb-4"
                                style={{ backgroundColor: c.accent }}
                            />
                            <h2 className="text-base md:text-lg font-semibold tracking-tight">
                                {c.title}
                            </h2>
                            <p className="text-xs text-zinc-300 mt-1">{c.subtitle}</p>
                            <p className="text-sm text-zinc-200 mt-4 leading-relaxed">
                                {c.body}
                            </p>
                            <Button
                                data-testid={`design-preview-pick-${c.slug}`}
                                className="mt-6 w-full h-10 bg-white text-black hover:bg-zinc-200"
                                asChild
                            >
                                <Link to={`/design-preview/home/${c.slug}`}>Bu yönde ilerleyelim</Link>
                            </Button>
                        </article>
                    ))}
                </div>
            </div>
        </main>
    );
}
